import { useMemo } from 'react';
import { MenuNavigationShellPage } from '@/app/layout/MenuNavigationShellPage';
import type { AgendaRegistration } from '@/app/layout/MenuNavigationShellPage';
import { calendarAgenda, CalendarPage } from './calendar';
import { PLANNER_PERMISSION } from './permissions';

/**
 * Route entry pro agendu „Kalendář zájezdů“ (planner calendar).
 *
 * Samostatná root agenda vedle planner shellu — běžná (overlay) agenda
 * s měsíčním kalendářem termínů. Zakládací popover i drawer termínu jsou
 * in-page prvky, žádné další agendy se neregistrují.
 */
export function PlannerCalendarSlicePage() {
  const agendas: AgendaRegistration[] = useMemo(
    () => [{ agenda: calendarAgenda, component: CalendarPage, permission: PLANNER_PERMISSION }],
    []
  );

  return <MenuNavigationShellPage agendas={agendas} rootAgenda={calendarAgenda} />;
}
